'use strict';

function parse(reader) {
    reader.readUInt32LE("data.timestamp", timeFilter);
    reader.readBit(1, "data.din");
    reader.readBit(1, "data.dout");
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/lora/v1_1/uart/change-report-parser.js